import {toJS} from "mobx";
import { FormBean } from "../datatypes";

const uiViewPrefix= "ui-view";
const domainObjectPrefix= "domain-object";

export function getValueList(formBean:FormBean, valueList:any, objectName:string, attrName:string, componentId:string) {
    let dataList = [] as {[key:string]:any}[];
    let dropDownListValue = "key";
    let dropDownListKey = "text";
    if(!valueList){
        //case-1: If dropdown control did not override the valueList => We need to get the valueList from domain-object namespace.
        let valueListStoreKey = domainObjectPrefix+'.'+objectName+"."+attrName;
        let valueListObj = getValueListFromStore(valueListStoreKey, formBean);
        dataList  = valueListObj.valueList;
        dropDownListKey = valueListObj.dropDownListKey;
        dropDownListValue = valueListObj.dropDownListValue;
    }else{
        // case-2: If dropdown control overrides the valueList => we need to get the value list from ui-view namespace.
        let valueListStoreKey = uiViewPrefix+'.'+formBean.CurrentViewName +'.'+ componentId;

        let valueListObj = getValueListFromStore(valueListStoreKey, formBean);
        dataList  = valueListObj.valueList;
        dropDownListKey = valueListObj.dropDownListKey;
        dropDownListValue = valueListObj.dropDownListValue;
    }

    return{
        dataList:dataList,
        dropDownListKey:dropDownListKey,
        dropDownListValue:dropDownListValue
    }
}

export function getValueListFromStore(key:string, formBean:any){
    let valueListFromStore = formBean.valueListStore[key];
    let convertedValueList = valueListFromStore ? JSON.parse(JSON.stringify(toJS(valueListFromStore))) : [];
    let valueList = convertedValueList ? convertedValueList.valueList : [];
    let dropDownListKey = convertedValueList.keyAttrName;
    let dropDownListValue = convertedValueList.textAttrName;

    return{
        valueList : valueList,
        dropDownListKey : dropDownListKey,
        dropDownListValue: dropDownListValue
    }
}